// import Tween from 'gsap-promise';

import { bindEvents, addListener, removeListener, getPseudoProperty, lerp, clamp } from '../../assets/js/helpers';

export const selector = 'locations';

export default class Locations {

	constructor(section) {
		this.el = {
			section,
			rotator: section.querySelector(`.${selector}__rotator`),
			images: section.querySelectorAll(`.${selector}__location-image`),
			titles: section.querySelectorAll(`.${selector}__location-title`)
		};

		this.state = null;

		this.targetX = 0;
		this.easedX = 0;
		this.touchX = 0;
		this.lastTouchX = 0;
		this.ease = 0.1;
		this.index = 0;
		this.totalSlideWidth = 0;
		this.amountDragged = 0;

		this.minDragAmount = 0;

		this.timer = null;
		this.timerDelay = 10;

		this.events = bindEvents(this);
		this.addEventListeners();
	}

	checkState() {
		this.state = getPseudoProperty(this.el.section, 'content');
	}

	measure() {
		this.totalSlideWidth = this.el.images[this.el.images.length - 1].offsetLeft;
		this.minDragAmount = this.el.section.clientWidth * 0.333;
	}

	updateImages(targetId) {
		for (const image of this.el.images) {
			image.classList.remove('is-active');
		}

		const targetEl = this.el.section.querySelector(`#${targetId}`);

		if (targetEl) {
			targetEl.classList.add('is-active');
		}
	}

	updateTitles(targetId) {
		for (const title of this.el.titles) {
			title.classList.remove('is-active');

			if (title.getAttribute('data-target') === targetId) {
				title.classList.add('is-active');
			}
		}
	}

	updateSlider() {
		let nextIndex = this.index;
		let slideDelta = 0;

		for (const image of this.el.images) {
			image.classList.remove('is-active');
		}

		if (Math.abs(this.amountDragged) >= this.minDragAmount) {
			if (this.amountDragged < 0) {
				nextIndex++;
			} else {
				nextIndex--;
			}
		}

		// Check if user scrolled more than 1 slide
		if (Math.abs(this.amountDragged) >= this.el.section.clientWidth) {
			slideDelta = (0 - Math.round(this.amountDragged / this.el.section.clientWidth));
		}

		nextIndex += slideDelta;
		nextIndex = clamp(nextIndex, 0, this.el.images.length);

		this.index = nextIndex;
		this.targetX = 0 - this.el.images[this.index].offsetLeft;

		this.el.images[this.index].classList.add('is-active');
	}

	setTimer(el) {
		this.timer = setTimeout(() => {
			const targetId = el.getAttribute('data-target');
			this.updateImages(targetId);
			this.updateTitles(targetId);
		}, this.timerDelay);
	}

	resetTimer() {
		clearTimeout(this.timer);
	}

	_onTitleMouseEnter(e) {
		this.resetTimer();
		this.setTimer(e.currentTarget);
	}

	_onTitleMouseLeave() {}

	_onWindowLoad() {
		this.checkState();
		this.measure();
	}

	_onWindowResize() {
		this.checkState();
		this.measure();
	}

	_onTick() {
		if (this.state === 'slider') {
			this.easedX = lerp(this.easedX, this.targetX, this.ease);

			TweenMax.set(this.el.images, {
				x: this.easedX
			});
		} else {
			TweenMax.set(this.el.images, {
				clearProps: 'x'
			});
		}
	}

	_onTouchStart(e) {
		this.amountDragged = 0;
		this.touchX = e.touches[0].clientX;
		this.lastTouchX = this.touchX;
	}

	_onTouchEnd() {
		this.touchX = 0;
		this.lastTouchX = this.touchX;
		this.updateSlider();
	}

	_onTouchMove(e) {
		this.lastTouchX = this.touchX;
		this.touchX = e.touches[0].clientX;

		let delta = this.touchX - this.lastTouchX;

		if (((0 - this.targetX) <= 0 && delta > 0) || ((0 - this.targetX) >= this.totalSlideWidth && delta < 0)) {
			delta *= 0.1;
		}

		this.amountDragged += delta;
		this.targetX += delta;
	}

	addEventListeners() {
		addListener(this.el.titles, 'mouseenter', this.events._onTitleMouseEnter);
		addListener(this.el.titles, 'mouseleave', this.events._onTitleMouseLeave);

		TweenMax.ticker.addEventListener('tick', this.events._onTick);
		this.el.section.addEventListener('touchstart', this.events._onTouchStart);
		this.el.section.addEventListener('touchend', this.events._onTouchEnd);
		this.el.section.addEventListener('touchmove', this.events._onTouchMove);

		window.addEventListener('resize', this.events._onWindowResize);
		window.addEventListener('load', this.events._onWindowLoad);
	}

	removeEventListeners() {
		removeListener(this.el.titles, 'mouseenter', this.events._onTitleMouseEnter);
		removeListener(this.el.titles, 'mouseleave', this.events._onTitleMouseLeave);

		TweenMax.ticker.removeEventListener('tick', this.events._onTick);
		this.el.section.removeEventListener('touchstart', this.events._onTouchStart);
		this.el.section.removeEventListener('touchend', this.events._onTouchEnd);
		this.el.section.removeEventListener('touchmove', this.events._onTouchMove);

		window.removeEventListener('resize', this.events._onWindowResize);
		window.removeEventListener('load', this.events._onWindowLoad);
	}

	destory() {
		this.removeEventListeners();
	}

}
